import { appPaths } from "@clockwise/web-commons/src/constants/route.constants";
import { useRouter } from "found";
import { useEffectOnce } from "usehooks-ts";
import { useProcessMessage } from "./hooks/useProcessMessage";
import { findMessageToProcess } from "./utils/findMessageToProcess";

export const AIDeepLinkSync = () => {
  const { match, router } = useRouter();
  const { processMessage } = useProcessMessage();

  const redirectToBaseAIUrl = () => {
    router.push(appPaths.ai);
  };

  useEffectOnce(() => {
    if (match.location.search) {
      const message = findMessageToProcess(match.location.search);

      if (message) {
        void processMessage(...message);
        redirectToBaseAIUrl();
      }
    }
  });

  return null;
};
